import {
  Box,
  Flex,
  Image,
  ModalBody,
  SimpleGrid,
  Text,
  useMediaQuery,
  ModalCloseButton,
  ModalOverlay,
  ModalContent,
  Modal
} from '@chakra-ui/react';
import Button from 'components/atoms/Button/Button';
import ListCheckIcon from 'components/atoms/Icon/list-check';
import NewProductCard from 'components/atoms/NewProductCard/NewProductCard';
import CartContext from 'context/CartProvider';
import { navigate } from 'gatsby';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useCartStore } from 'stores/cart';
import CurrencyFormatter from '../../atoms/CurrencyFormatter/CurrencyFormatter';
import AdjustItem from '../AdjustItem/AdjustItem';
import Icon from '../../atoms/Icon/Icon';
import { get } from 'lodash';
import { isMadPawsStore } from '../../../common/util';
import Loader from '../../atoms/Loader/Loader';
import { PetHealthContainer, RecommendationContainer } from './ProductDetails.styled';
import { changeItemQty, deleteItem, changeSubQty, cancelSubscription } from 'common/orderGroove';
import { delay } from 'common/util';
import { bcLoginUrl } from 'helpers/bigcommerce';
import ShippingFree from '../ShippingFree/ShippingFree';

const ProductCartDetails = ({
  thumbnail,
  product,
  priceObj,
  recommendations,
  isOpen,
  selectedVariant,
  useAutoShip,
  isMedication,
  styles,
  orderGrooveItem = null,
  customerId,
  fetchOGItem,
  fetchSubItem,
  oneTimeItemPurchase,
  hideSWidget,
  sethideSWidget
}) => {
  const ctx = useContext(CartContext) || { state: { cart: {} } };
  const checkout = get(ctx, 'state.checkout', {});
  const { state, updateCartItemQuantity, removeItemFromCart } = ctx;
  const cart = state.cart?.lineItems?.physical_items;
  const { updatingItem } = state;
  const { setCartModal, upsellAction } = useCartStore(state => state);
  const [isPc] = useMediaQuery('(min-width: 992px)', {
    ssr: true,
    fallback: false // return false on the server, and re-evaluate on the client side
  });

  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    // Cleanup function to reset overflow property when component unmounts
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  //separate items with option name Autoship Frequency.
  const cartItem = useMemo(() => {
    let ItemsOnCart = cart?.filter(
      item =>
        !!!item.options.find(option => option.name === 'Ships Every') &&
        item.product_id === product.entityId
    );
    if (useAutoShip) {
      ItemsOnCart = cart?.filter(
        item =>
          item.options.find(option => option.name === 'Ships Every') &&
          item.product_id === product.entityId
      );
    }
    const currentItem = ItemsOnCart?.find(i => {
      const sizeVariants = i.options.find(option => option.name === 'Select Size');
      if (sizeVariants && selectedVariant) {
        return sizeVariants.valueId === selectedVariant.id;
      }
      return i.product_id === product.entityId;
    });
    return currentItem;
  }, [cart, selectedVariant]);

  useEffect(() => {
    let updatingItem = false;
    if (updatingItem === cartItem?.id) {
      updatingItem = true;
    }
    setIsUpdating(updatingItem);
  }, [cartItem, updatingItem]);

  const changeOGItemQty = async (item, newQty) => {
    setIsUpdating(true);
    if (oneTimeItemPurchase) {
      const requestData = { id: item.public_id, quantity: newQty };
      await changeItemQty(requestData, customerId);
    } else {
      const requestData = { id: item.subscription, quantity: newQty };
      await changeSubQty(requestData, customerId);
    }
    await fetchOGItem();
    await fetchSubItem();
    await delay(1000);
    setIsUpdating(false);
  };

  const currentItem = upsellAction ? orderGrooveItem : cartItem;
  const updateItemAction = upsellAction ? changeOGItemQty : updateCartItemQuantity;
  const deleteOGItem = async () => {
    if (oneTimeItemPurchase) {
      await deleteItem(currentItem.public_id, customerId);
    } else {
      await cancelSubscription(currentItem.subscription, customerId);
    }
    await fetchSubItem();
    await fetchOGItem();
  };

  const goToAutoShip = () => {
    const autoShipUrl = '/subscriptions';
    bcLoginUrl(customerId, autoShipUrl).then(url => {
      // console.log("Logged in", url);
      window.location = url;
    });
  };

  const recommendationsAddedToCart = (url = null) => {
    navigate(url);
  };

  const cartActions = (
    <Flex justifyContent="space-between" mt="16px">
      <Button
        className={styles.productShopBtn}
        level={isPc ? 'ghost' : 'link2'}
        type={'button'}
        onClick={() => setCartModal(false)}
      >
        Continue shopping
      </Button>
      <Button
        className={styles.productToCartBtn}
        level={'tertiary'}
        type={'button'}
        onClick={() => {
          setCartModal(false);
          upsellAction ? goToAutoShip() : navigate('/confirm-order');
        }}
      >
        {upsellAction ? 'View Autoship' : 'VIEW CART'}
      </Button>
    </Flex>
  );
  const recomendationListHTML = () => {
    return (
      recommendations?.length > 0 && (
        <RecommendationContainer $hideSWidget={hideSWidget}>
          <Box
            px={{ base: '16px', lg: '40px' }}
            pt={{ base: '24px', lg: '32px' }}
            lineHeight={{ base: '1.2', lg: '25.2px' }}
          >
            <Text
              mb="16px"
              fontFamily={'Recoleta'}
              fontWeight={'600'}
              fontSize={{
                base: '18px',
                lg: '21px'
              }}
              color={isMadPawsStore() ? '#414141' : '#202020'}
            >
              Pet owners also bought
            </Text>
            {isPc ? (
              <SimpleGrid columns={2} gap="12px" className={styles.recommendations}>
                {recommendations?.slice(0, 4).map(node => (
                  <NewProductCard
                    slim
                    showIcon
                    sku={node.sku}
                    key={node.entityId}
                    image={node.defaultImage?.url}
                    productId={node.entityId}
                    name={node.name}
                    price={node.price}
                    salePrice={node.calculated_price}
                    rating={node.reviews_rating_sum}
                    ratingCount={node.reviews_count}
                    url={node.custom_url.url}
                    variantId={node.variants?.[0]?.id}
                    addToCart
                    addAdditionalAction={recommendationsAddedToCart}
                    disabled={!!cart?.find(item => item.product_id === node.entityId)}
                  />
                ))}
              </SimpleGrid>
            ) : (
              <Flex gap={3} overflowX={'auto'} className={styles.recommendations}>
                {recommendations?.slice(0, 4).map(node => (
                  <NewProductCard
                    slim
                    showIcon
                    sku={node.sku}
                    key={node.entityId}
                    image={node.defaultImage?.url}
                    productId={node.entityId}
                    name={node.name}
                    price={node.price}
                    salePrice={node.calculated_price}
                    rating={node.reviews_rating_sum}
                    ratingCount={node.reviews_count}
                    url={node.custom_url.url}
                    variantId={node.variants?.[0]?.id}
                    addToCart
                    disabled={!!cart?.find(item => item.product_id === node.entityId)}
                  />
                ))}
              </Flex>
            )}
          </Box>
        </RecommendationContainer>
      )
    );
  };

  const footerModalHTML = () => {
    let totalAmount = checkout?.grand_total ?? cart?.cartAmount;
    let totalText = 'Total in cart:';
    let itemLength = state.cart.numberItems;
    if (upsellAction && currentItem) {
      totalAmount = currentItem.total_price;
      totalText = 'Total in next AutoShip:';
      itemLength = 0;
    }
    return (
      <Box
        position="fixed"
        bottom="0"
        zIndex="9999"
        bg="white"
        width="-webkit-fill-available"
        px={{ base: '16px', lg: '24px' }}
        py="24px"
        boxShadow={'0px 0px 2px 0px #00000026'}
      >
        {isUpdating || !totalAmount || updatingItem ? (
          <Flex justifyContent={'center'}>
            <Loader />
          </Flex>
        ) : (
          <>
            {!upsellAction && (
              <ShippingFree totalAmount={totalAmount} sethideSWidget={sethideSWidget} />
            )}
            {state.cart && oneTimeItemPurchase && (
              <SimpleGrid columns={2} alignItems={'center'}>
                <Flex flexWrap={'wrap'} color={isMadPawsStore() ? '#414141' : '#202020'}>
                  <Text fontWeight={700}>{totalText}&nbsp;</Text>
                  {itemLength > 0 && `${itemLength} ${itemLength > 1 ? 'items' : 'item'}`}
                </Flex>
                <Text textAlign={'right'} fontSize={'18px'} fontWeight={700}>
                  <CurrencyFormatter appendZero={true} currency={'AUD'} amount={totalAmount} />
                </Text>
              </SimpleGrid>
            )}
            {cartActions}
          </>
        )}
      </Box>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setCartModal(false)}
      size={'full'}
      motionPreset="slideInRight"
    >
      <ModalOverlay />
      <ModalContent
        overflow={'hidden'}
        maxW={'495px'}
        mt={{ base: isMadPawsStore() ? '150px' : '158px', lg: '0px' }}
        containerProps={{
          justifyContent: 'flex-end',
          overflow: recommendations.length > 0 ? 'auto' : 'hidden'
        }}
      >
        <ModalBody p={0}>
          <Box
            pb="24px"
            borderBottom="1px"
            borderColor={isMadPawsStore() ? '#EAEAEA' : 'var(--grey-05)'}
          >
            <SimpleGrid gap={{ base: '28px' }} px={{ base: '16px', lg: '32px' }} py="24px">
              <Flex align={'center'} color={'#238254'}>
                <Box mr="8px" flexShrink={0}>
                  <ListCheckIcon isMobile={!isPc} />
                </Box>
                <Text
                  fontSize={{ base: '16px', lg: '18px' }}
                  whiteSpace={'nowrap'}
                  color={isMadPawsStore() ? '#227979' : '#238254'}
                  fontWeight={{
                    base: '400',
                    lg: '700'
                  }}
                >
                  {upsellAction ? 'Item added to your next Autoship' : 'Item added to your cart'}
                </Text>
              </Flex>
              <ModalCloseButton
                top="16px"
                right="16px"
                color={isMadPawsStore() ? '#6B6B6B' : '#202020'}
              />
            </SimpleGrid>
            <SimpleGrid
              gap={{ base: '28px' }}
              templateColumns="1fr 2fr"
              px={{ base: '16px', lg: '32px' }}
            >
              <Flex direction={{ base: 'row', lg: 'column' }} gap={4}>
                <Box w={'112px'} h={'112px'}>
                  <Image src={thumbnail} h={'100%'} w={'100%'} objectFit={'contain'} />
                </Box>
              </Flex>
              <Box>
                <Text fontWeight={500} color={isMadPawsStore() ? '#414141' : '#202020'}>
                  {product.name}
                </Text>
                {selectedVariant && (
                  <Text
                    color={isMadPawsStore() ? '#565656' : 'var(--charcoal-02)'}
                    pt={{ base: '4px', lg: '2px' }}
                    fontSize={{ base: '14px', lg: '16px' }}
                  >
                    {selectedVariant.label}
                  </Text>
                )}
                <Text
                  fontWeight={700}
                  mt="4px"
                  mb="8px"
                  color={isMadPawsStore() ? '#414141' : '#202020'}
                >
                  <strong>${priceObj.calculated_price}</strong>
                </Text>

                {currentItem && (
                  <>
                    {isUpdating ? (
                      <Flex justifyContent={'center'}>
                        <Loader />
                      </Flex>
                    ) : (
                      <Flex
                        justifyContent={'space-between'}
                        flexWrap="wrap"
                        width="-webkit-fill-available"
                      >
                        <AdjustItem
                          isCart={true}
                          item={currentItem}
                          cartType={'full'}
                          updatingItem={updatingItem}
                          updateCartItemQuantity={updateItemAction}
                          className={styles.adjustItem}
                        />
                        <span
                          data-button
                          tabIndex={0} // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
                          role="presentation"
                          className={`${styles.removeItemBtn} icon-wrap ml-4`}
                          onClick={() => {
                            upsellAction ? deleteOGItem() : removeItemFromCart(cartItem.id);
                            setCartModal(false);
                          }}
                        >
                          {oneTimeItemPurchase ? (
                            <>
                              Remove&nbsp;
                              <Icon symbol="bin" />
                            </>
                          ) : (
                            <>Cancel</>
                          )}
                        </span>
                      </Flex>
                    )}
                  </>
                )}
              </Box>
            </SimpleGrid>
            {isMedication && (
              <PetHealthContainer $isMadPawsStore={isMadPawsStore}>
                <Icon symbol="prescriptionWarning" />
                <Box>
                  <Text
                    fontWeight={700}
                    color={isMadPawsStore() ? '#414141' : 'var(--grey-alt-darker)'}
                    mb="4px"
                  >
                    For your pet’s health and safety
                  </Text>
                  <Text
                    fontSize={14}
                    color={isMadPawsStore() ? '#565656' : 'var(--grey-alt-darker)'}
                  >
                    We will collect your pet’s prescription and vet clinic information at checkout
                    as required by regulation.
                  </Text>
                </Box>
              </PetHealthContainer>
            )}
          </Box>
          {recomendationListHTML()}
          {footerModalHTML()}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ProductCartDetails;
